import React from "react";
import { Card, Row, Col, Table, Button } from "react-bootstrap";

function AdminDashboard() {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold text-dark mb-1">Dashboard</h2>
          <p className="text-muted mb-0">
            Xin chào, đây là tổng quan ngày hôm nay.
          </p>
        </div>
        <div className="d-flex gap-2">
          <Button variant="light" className="shadow-sm border-0">
            <i className="bi bi-bell"></i>
          </Button>
          <Button
            className="shadow-sm rounded-pill px-4 text-white border-0"
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            }}
          >
            <i className="bi bi-cloud-download me-2"></i> Xuất Báo Cáo
          </Button>
        </div>
      </div>

      {/* Stats Cards */}
      <Row className="mb-4 g-4">
        <Col md={3}>
          <Card
            className="h-100 border-0 rounded-4 shadow-sm text-white position-relative overflow-hidden"
            style={{
              background: "linear-gradient(45deg, #7367f0, #9e95f5)",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
            }}
          >
            <Card.Body className="p-4">
              <h6
                className="text-uppercase mb-3 opacity-75"
                style={{ letterSpacing: "1px" }}
              >
                Khách hàng mới
              </h6>
              <div className="d-flex align-items-end justify-content-between">
                <h2 className="display-5 fw-bold mb-0">3,050</h2>
                <span className="badge bg-white text-primary rounded-pill mb-1 p-2">
                  <i className="bi bi-arrow-up-short"></i> 15%
                </span>
              </div>
              <i
                className="bi bi-people-fill position-absolute opacity-25 fs-1"
                style={{
                  right: "-10px",
                  bottom: "-10px",
                  fontSize: "6rem",
                  transform: "rotate(-15deg)",
                }}
              ></i>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card
            className="h-100 border-0 rounded-4 shadow-sm text-white position-relative overflow-hidden"
            style={{
              background: "linear-gradient(45deg, #00cfe8, #66e4f3)",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
            }}
          >
            <Card.Body className="p-4">
              <h6
                className="text-uppercase mb-3 opacity-75"
                style={{ letterSpacing: "1px" }}
              >
                Doanh thu tuần
              </h6>
              <div className="d-flex align-items-end justify-content-between">
                <h2 className="display-5 fw-bold mb-0">$80.5k</h2>
                <span className="badge bg-white text-info rounded-pill mb-1 p-2">
                  +5.2%
                </span>
              </div>
              <i
                className="bi bi-wallet2 position-absolute opacity-25 fs-1"
                style={{
                  right: "-10px",
                  bottom: "-10px",
                  fontSize: "6rem",
                  transform: "rotate(-15deg)",
                }}
              ></i>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card
            className="h-100 border-0 rounded-4 shadow-sm text-white position-relative overflow-hidden"
            style={{
              background: "linear-gradient(45deg, #ff9f43, #ffc085)",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
            }}
          >
            <Card.Body className="p-4">
              <h6
                className="text-uppercase mb-3 opacity-75"
                style={{ letterSpacing: "1px" }}
              >
                Booking mới
              </h6>
              <div className="d-flex align-items-end justify-content-between">
                <h2 className="display-5 fw-bold mb-0">42</h2>
                <span className="badge bg-white text-warning rounded-pill mb-1 p-2">
                  Pending
                </span>
              </div>
              <i
                className="bi bi-calendar-range position-absolute opacity-25 fs-1"
                style={{
                  right: "-10px",
                  bottom: "-10px",
                  fontSize: "6rem",
                  transform: "rotate(-15deg)",
                }}
              ></i>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card
            className="h-100 border-0 rounded-4 shadow-sm text-white position-relative overflow-hidden"
            style={{
              background: "linear-gradient(45deg, #ea5455, #f0898a)",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
            }}
          >
            <Card.Body className="p-4">
              <h6
                className="text-uppercase mb-3 opacity-75"
                style={{ letterSpacing: "1px" }}
              >
                Sắp hết hàng
              </h6>
              <div className="d-flex align-items-end justify-content-between">
                <h2 className="display-5 fw-bold mb-0">05</h2>
                <span className="badge bg-white text-danger rounded-pill mb-1 p-2">
                  Alert
                </span>
              </div>
              <i
                className="bi bi-box-seam position-absolute opacity-25 fs-1"
                style={{
                  right: "-10px",
                  bottom: "-10px",
                  fontSize: "6rem",
                  transform: "rotate(-15deg)",
                }}
              ></i>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modern Table Section */}
      <Row>
        <Col lg={8} className="mb-4">
          <Card
            className="border-0 rounded-4 shadow-sm h-100"
            style={{ background: "white", overflow: "hidden" }}
          >
            <Card.Header className="bg-white border-0 py-4 px-4 d-flex justify-content-between align-items-center">
              <div>
                <h5 className="fw-bold mb-0 text-dark">Sản phẩm bán chạy</h5>
                <small className="text-muted">
                  Danh sách các món được order nhiều nhất
                </small>
              </div>
              <Button
                variant="outline-light"
                size="sm"
                className="text-muted border-0"
              >
                <i className="bi bi-three-dots fs-5"></i>
              </Button>
            </Card.Header>
            <Card.Body className="p-0">
              <Table hover responsive className="mb-0 align-middle">
                <thead>
                  <tr style={{ background: "#f8f8fb", borderBottom: "none" }}>
                    <th
                      className="ps-4 py-4 text-uppercase small fw-bold text-muted"
                      style={{ fontSize: "0.8rem", letterSpacing: "0.8px" }}
                    >
                      Sản phẩm
                    </th>
                    <th
                      className="py-4 text-uppercase small fw-bold text-muted"
                      style={{ fontSize: "0.8rem", letterSpacing: "0.8px" }}
                    >
                      Category
                    </th>
                    <th
                      className="py-4 text-uppercase small fw-bold text-muted"
                      style={{ fontSize: "0.8rem", letterSpacing: "0.8px" }}
                    >
                      Giá
                    </th>
                    <th
                      className="py-4 text-uppercase small fw-bold text-muted"
                      style={{ fontSize: "0.8rem", letterSpacing: "0.8px" }}
                    >
                      Tồn kho
                    </th>
                    <th
                      className="py-4 text-uppercase small fw-bold text-muted"
                      style={{ fontSize: "0.8rem", letterSpacing: "0.8px" }}
                    >
                      Trạng thái
                    </th>
                    <th
                      className="py-4 text-uppercase small fw-bold text-muted"
                      style={{ fontSize: "0.8rem", letterSpacing: "0.8px" }}
                    >
                      Tùy chỉnh
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      name: "Cà phê đen đá",
                      cat: "Drink",
                      price: "25.000đ",
                      stock: "15",
                      status: "low-stock",
                      statusText: "Sắp hết",
                      color: "#6610f2",
                    },
                    {
                      name: "Trà sữa trân châu",
                      cat: "Drink",
                      price: "45.000đ",
                      stock: "150",
                      status: "in-stock",
                      statusText: "Còn hàng",
                      color: "#fd7e14",
                    },
                    {
                      name: "Bánh Tiramisu",
                      cat: "Food",
                      price: "35.000đ",
                      stock: "45",
                      status: "in-stock",
                      statusText: "Còn hàng",
                      color: "#198754",
                    },
                    {
                      name: "Sinh tố bơ",
                      cat: "Drink",
                      price: "40.000đ",
                      stock: "0",
                      status: "out-stock",
                      statusText: "Hết hàng",
                      color: "#20c997",
                    },
                    {
                      name: "Croissant",
                      cat: "Food",
                      price: "20.000đ",
                      stock: "32",
                      status: "in-stock",
                      statusText: "Còn hàng",
                      color: "#ffc107",
                    },
                  ].map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        borderBottom: index < 4 ? "1px solid #ebe9f1" : "none",
                      }}
                    >
                      <td className="ps-4 py-4">
                        <div className="d-flex align-items-center">
                          <div
                            className="d-flex align-items-center justify-content-center me-3 fw-bold rounded-3 fs-5"
                            style={{
                              width: "45px",
                              height: "45px",
                              color: item.color,
                              background: `${item.color}20`,
                            }}
                          >
                            {item.name.charAt(0)}
                          </div>
                          <span className="fw-bold text-dark">{item.name}</span>
                        </div>
                      </td>
                      <td className="py-4 text-muted fw-semibold">
                        {item.cat}
                      </td>
                      <td className="py-4">
                        <span className="fw-bold">{item.price}</span>
                      </td>
                      <td className="py-4 text-muted fw-semibold">
                        {item.stock}
                      </td>
                      <td className="py-4">
                        <span
                          className={`px-3 py-2 rounded-pill small fw-bold text-uppercase`}
                          style={{
                            fontSize: "0.75rem",
                            background:
                              item.status === "in-stock"
                                ? "rgba(40, 199, 111, 0.12)"
                                : item.status === "low-stock"
                                ? "rgba(255, 159, 67, 0.12)"
                                : "rgba(234, 84, 85, 0.12)",
                            color:
                              item.status === "in-stock"
                                ? "#28c76f"
                                : item.status === "low-stock"
                                ? "#ff9f43"
                                : "#ea5455",
                          }}
                        >
                          {item.statusText}
                        </span>
                      </td>
                      <td className="py-4">
                        <div className="d-flex">
                          <Button
                            variant="light"
                            size="sm"
                            className="d-flex align-items-center justify-content-center me-2 border-0"
                            style={{
                              width: "32px",
                              height: "32px",
                              padding: 0,
                              borderRadius: "8px",
                              color: "#6e6b7b",
                              transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#7367f0";
                              e.currentTarget.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#f8f9fa";
                              e.currentTarget.style.color = "#6e6b7b";
                            }}
                          >
                            <i className="bi bi-pencil"></i>
                          </Button>
                          <Button
                            variant="light"
                            size="sm"
                            className="d-flex align-items-center justify-content-center border-0"
                            style={{
                              width: "32px",
                              height: "32px",
                              padding: 0,
                              borderRadius: "8px",
                              color: "#6e6b7b",
                              transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#7367f0";
                              e.currentTarget.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#f8f9fa";
                              e.currentTarget.style.color = "#6e6b7b";
                            }}
                          >
                            <i className="bi bi-trash"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} className="mb-4">
          <Card
            className="border-0 rounded-4 shadow-sm h-100"
            style={{ overflow: "hidden" }}
          >
            <Card.Header className="bg-white border-0 py-4 px-4">
              <h5 className="fw-bold mb-0 text-dark">Nguồn khách hàng</h5>
              <small className="text-muted">Phân tích nguồn truy cập</small>
            </Card.Header>
            <Card.Body className="d-flex flex-column align-items-center justify-content-center p-4">
              <div
                className="position-relative d-flex justify-content-center align-items-center mb-5 mt-2"
                style={{ width: "220px", height: "220px" }}
              >
                {/* CSS only donut chart representation */}
                <svg width="100%" height="100%" viewBox="0 0 42 42">
                  <circle
                    cx="21"
                    cy="21"
                    r="15.91549430918954"
                    fill="#fff"
                  ></circle>
                  <circle
                    cx="21"
                    cy="21"
                    r="15.91549430918954"
                    fill="transparent"
                    stroke="#f2f2f2"
                    strokeWidth="5"
                  ></circle>
                  <circle
                    cx="21"
                    cy="21"
                    r="15.91549430918954"
                    fill="transparent"
                    stroke="#7367f0"
                    strokeWidth="5"
                    strokeDasharray="70 30"
                    strokeDashoffset="25"
                  ></circle>
                  <circle
                    cx="21"
                    cy="21"
                    r="15.91549430918954"
                    fill="transparent"
                    stroke="#ff9f43"
                    strokeWidth="5"
                    strokeDasharray="20 80"
                    strokeDashoffset="55"
                  ></circle>
                  <circle
                    cx="21"
                    cy="21"
                    r="15.91549430918954"
                    fill="transparent"
                    stroke="#ea5455"
                    strokeWidth="5"
                    strokeDasharray="10 90"
                    strokeDashoffset="35"
                  ></circle>
                </svg>
                <div className="position-absolute text-center">
                  <h2 className="mb-0 fw-bold">85%</h2>
                  <small className="text-muted">Tăng trưởng</small>
                </div>
              </div>
              <div className="w-100 px-2">
                <div
                  className="d-flex justify-content-between mb-3 p-2 rounded"
                  style={{ backgroundColor: "#f8f8f8" }}
                >
                  <span className="d-flex align-items-center">
                    <i className="bi bi-circle-fill text-primary me-2"></i>Trực
                    tiếp
                  </span>
                  <span className="fw-bold">70%</span>
                </div>
                <div
                  className="d-flex justify-content-between mb-3 p-2 rounded"
                  style={{ backgroundColor: "#f8f8f8" }}
                >
                  <span className="d-flex align-items-center">
                    <i className="bi bi-circle-fill text-warning me-2"></i>
                    Social
                  </span>
                  <span className="fw-bold">20%</span>
                </div>
                <div
                  className="d-flex justify-content-between p-2 rounded"
                  style={{ backgroundColor: "#f8f8f8" }}
                >
                  <span className="d-flex align-items-center">
                    <i className="bi bi-circle-fill text-danger me-2"></i>Khác
                  </span>
                  <span className="fw-bold">10%</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default AdminDashboard;
